exports.getListOfCountriesForQuery =  function getListOfCountriesForQuery(countryData) {
    return function(query, populateResults) {
        const trimmedQuery = (query || '').toLocaleLowerCase().trim();
        if (!trimmedQuery) return populateResults([]);

        const individualWordsInQuery = words(trimmedQuery);

        let canonicalNamesMatched = [];
        let altNamesMatched = [];
        let anyOrderWordMatches = [];
        let canonicalNamesFuzzyMatched = [];

        countryData.forEach(entry => {
            const canonicalNameTrimmed = entry.canonicalName.toLocaleLowerCase().trim();

            if (isPrefix(trimmedQuery, canonicalNameTrimmed)) {
                canonicalNamesMatched.push(entry.canonicalName);
            } else if (entry.aliases.some(alias => isPrefix(trimmedQuery, alias.toLocaleLowerCase().trim()))) {
                altNamesMatched.push(entry.canonicalName);
            } else if (allWordsInQueryMatchTargetWord(individualWordsInQuery, canonicalNameTrimmed)
                || entry.aliases.some(alias => allWordsInQueryMatchTargetWord(individualWordsInQuery, alias.toLocaleLowerCase().trim()))) {
                anyOrderWordMatches.push(entry.canonicalName);
            } else if (isFuzzyMatch(trimmedQuery.toLocaleLowerCase(), canonicalNameTrimmed.toLocaleLowerCase())) {
                canonicalNamesFuzzyMatched.push(entry.canonicalName);
            }
        });

        // Remove duplicates while preserving order
        const seenMatches = new Set();
        const results = [...canonicalNamesMatched, ...altNamesMatched, ...anyOrderWordMatches, ...canonicalNamesFuzzyMatched].filter(name => {
            if (seenMatches.has(name)) return false;
            seenMatches.add(name);
            return true;
        });

        populateResults(results);
        return results;
    };
}

function words(str) {
    // Supports non-latin scripts
    return (str || '').toLowerCase().trim().replace(/[\p{P}\p{S}]/gu, ' ').split(/\s+/).filter(w => w);
}

function isPrefix(query, target) {
    return target.startsWith(query);
}

function allWordsInQueryMatchTargetWord(queryWords, target) {
    const targetWords = words(target);
    return queryWords.every(qw => targetWords.some(tw => tw.startsWith(qw)));
}

function isFuzzyMatch(query, target) {
    // Avoids over fuzzy matching very short strings
    if (query.length <= 4 || target.length <= 3) {
        return false
    }

    // Fuzzy matches if one letter different, added or removed
    for (let i = 0; i < query.length; i++) {
        const queryChar = query[i]
        const targetChar = target[i]

        if (i >= target.length || targetChar !== queryChar) {
            const earlierMatch = query.substring(0, i)
            const endOfQueryNotIncludingCurrentLetter = query.substring(i + 1)
            const endOfQueryIncludingCurrentLetter = query.substring(i)

            const queryWithLetterReplaced = earlierMatch + targetChar + endOfQueryNotIncludingCurrentLetter;
            const queryWithLetterRemoved = earlierMatch + endOfQueryNotIncludingCurrentLetter
            const queryWithLetterAdded = earlierMatch + targetChar + endOfQueryIncludingCurrentLetter

            return isPrefix(queryWithLetterReplaced, target) || isPrefix(queryWithLetterRemoved, target) || isPrefix(queryWithLetterAdded, target);
        }
    }

    return true
}

exports.isFuzzyMatch = isFuzzyMatch;